import { StyleSheet, View } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import {
    useClearCustomersSearch,
    useHasActiveCustomersSearch,
} from '@/stores/customers-search-store'
import { Button } from '@/ui/Button'
import { EmptyCard } from '@/ui/EmptyCard'

interface CustomersEmptyStateProps {
    hasAnyCustomers: boolean
    onAddCustomer: () => void
}

export function CustomersEmptyState({ hasAnyCustomers, onAddCustomer }: CustomersEmptyStateProps) {
    const theme = useTheme()
    const hasActiveSearch = useHasActiveCustomersSearch()
    const clearSearch = useClearCustomersSearch()

    if (!hasAnyCustomers) {
        return (
            <EmptyCard
                icon="domain"
                title="No customers yet"
                subtitle="Add customers to manage their information and track details"
                buttonLabel="Add Customer"
                onButtonPress={onAddCustomer}
            />
        )
    }

    if (hasActiveSearch) {
        return (
            <View style={styles.container}>
                <Text variant="bodyLarge" style={{ color: theme.colors.onSurfaceVariant }}>
                    No matches
                </Text>
                <Text variant="bodyMedium" style={{ color: theme.colors.onSurfaceVariant }}>
                    Try adjusting your search
                </Text>
                <Button
                    title="Show All"
                    mode="outlined"
                    onPress={clearSearch}
                    style={styles.button}
                />
            </View>
        )
    }

    return null
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 48,
        gap: 8,
    },
    button: {
        marginTop: 8,
    },
})
